var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "109.05855mm",
    height: "32mm",
    viewBox: "0 0 109.05855 32",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-40.000001,-120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g989",
    transform: "matrix(1.0150041,0,0,1.0150041,-2.9294147,-1.4872722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "#f7a600",
      fillOpacity: 1,
      strokeWidth: 0.0331785
    },
    d: "m 69.969011,119.69356 c -3.995621,0.0694 -7.955527,1.82266 -10.643278,4.76922 0.53307,0.26207 1.060995,0.53418 1.584399,0.81494 3.060245,-1.93145 6.974261,-2.52318 10.398849,-1.22835 1.547308,0.61842 2.992002,1.48209 4.118612,2.73058 1.235465,1.46845 3.884529,1.04285 4.619873,-0.73277 0.521319,-1.06576 0.276758,-2.48195 -0.629419,-3.26389 -2.084484,-1.61854 -4.655319,-2.6158 -7.26674,-2.95692 -0.723668,-0.10234 -1.453488,-0.14547 -2.182296,-0.13281 z m 12.922209,8.8191 c -0.03742,10e-4 -0.07364,0.009 -0.108521,0.0253 -0.741941,0.34108 0.290364,1.23517 0.594796,3.66644 0.45249,3.61369 -0.767553,7.42948 -3.228744,10.04435 0.457908,0.66358 0.889854,1.34471 1.283126,2.04949 0.158924,0.29095 0.317354,0.64942 0.119373,0.9617 -0.04481,0.21629 -0.362188,0.18237 -0.532267,0.21291 -0.493673,-0.16403 -0.69899,-0.70119 -1.015442,-1.07022 -0.289771,-0.40089 -0.588452,-0.79488 -0.894003,-1.18339 -0.814708,0.66543 -1.729333,1.21371 -2.736783,1.60558 -1.560664,0.49548 -3.6874,0.91789 -3.847311,2.93781 -0.375023,1.99396 1.84347,3.76927 3.710885,3.0272 3.649501,-1.57497 6.718118,-4.57251 8.210866,-8.27649 1.54972,-3.43154 1.45971,-7.90419 0.39171,-10.87324 -0.55729,-1.54928 -1.386377,-3.14535 -1.947685,-3.12746 z m -26.330176,3.1936 c -0.185426,0.007 -0.372785,0.0351 -0.559656,0.0868 -1.062264,0.23951 -1.827761,1.07865 -2.104264,2.1022 -0.345264,2.26038 -0.128535,4.5988 0.537951,6.78666 1.581321,5.3308 6.327181,9.63141 11.886613,10.35751 1.033177,0.0239 2.417597,0.46392 3.267501,-0.13126 0.123797,-0.20388 -0.01219,-0.5014 -0.242362,-0.5581 -2.144899,-0.36099 -4.266979,-1.13744 -5.982581,-2.50114 -3.75574,-2.80038 -5.544927,-8.03529 -4.028694,-12.50622 0.635108,-1.79025 -0.982062,-3.70387 -2.774508,-3.63647 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.739233,144.51381 c 2.850608,3.9891 -10.507725,-21.66952 -38.444414,-24.37098 11.568079,4.62806 14.848517,15.79254 28.880627,15.3874 -2.606284,0.66365 -5.657277,0.20269 -6.897765,-0.20682 1.204445,1.94861 7.745156,1.92967 9.298681,1.35007 2.651683,2.42638 4.706741,4.41303 7.162871,7.84033 z",
    id: "path3115-3",
    style: {
      display: "inline",
      mixBlendMode: "normal",
      fill: "#f7a600",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "TIS",
    transform: "matrix(0.93847831,0,0,0.76888938,11.751639,21.758706)",
    id: "text1759",
    style: {
      fontSize: "48.8305px",
      fill: "#f7a600",
      strokeWidth: 4.06922
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1717",
    style: {
      fontFamily: "'EnBW DIN Pro'",
      InkscapeFontSpecification: "'EnBW DIN Pro'"
    },
    d: "m 80.205078,132.49219 c 0,1.2832 0,2.5664 0,3.84961 3.352865,0 6.705729,0 10.058594,0 0,10.48242 0,20.96484 0,31.44726 1.589844,0 3.179687,0 4.769531,0 0,-10.48242 0,-20.96484 0,-31.44726 3.352865,0 6.705727,0 10.058597,0 0,-1.45964 0,-2.91927 0,-4.37891 -8.295576,0 -16.591149,0 -24.886722,0 0,0.17643 0,0.35287 0,0.5293 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1719",
    style: {
      fontFamily: "'EnBW DIN Pro'",
      InkscapeFontSpecification: "'EnBW DIN Pro'"
    },
    d: "m 110.52734,132.49219 c 0,11.76562 0,23.53125 0,35.29687 1.5905,0 3.18099,0 4.77149,0 0,-11.94205 0,-23.88411 0,-35.82617 -1.5905,0 -3.18099,0 -4.77149,0 0,0.17643 0,0.35287 0,0.5293 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1721",
    style: {
      fontFamily: "'EnBW DIN Pro'",
      InkscapeFontSpecification: "'EnBW DIN Pro'"
    },
    d: "m 133.26172,131.68164 c -3.4727,0.0664 -7.14204,1.37668 -9.20117,4.31055 -2.02288,2.85717 -2.34173,6.77178 -1.05476,9.99357 1.19719,2.9274 4.14894,4.71377 7.1352,5.36507 2.76803,0.67989 5.68827,0.64446 8.40313,1.54544 1.51552,0.61143 2.73076,1.97752 2.93635,3.63107 0.38817,2.08773 -0.19807,4.50628 -2.04478,5.73843 -2.39877,1.62403 -5.48659,1.59124 -8.2521,1.24595 -1.2935,-0.21038 -2.39144,-0.49561 -3.57102,-1.18205 -1.23499,-0.69506 -2.20612,-1.58664 -3.23171,-2.59725 -1.08104,1.07781 -2.16045,2.15727 -3.23828,3.23828 2.0971,2.17604 4.69572,3.98737 7.70655,4.57651 4.19392,0.88739 8.83978,0.83437 12.66259,-1.31088 2.98626,-1.63535 4.82042,-4.98752 4.78895,-8.36668 0.12064,-3.05032 -1.24631,-6.14629 -3.74208,-7.94777 -2.47194,-1.82829 -5.67543,-1.98077 -8.59722,-2.49948 -2.12286,-0.3337 -4.50374,-0.67252 -6.05633,-2.30611 -1.20063,-1.53894 -1.19399,-3.73641 -0.61033,-5.52248 0.60776,-1.80843 2.42006,-3.09499 4.15646,-3.44928 3.30336,-0.63923 7.02669,-0.075 9.59906,2.22626 0.4041,0.24626 0.81277,1.149 1.19391,0.4046 0.93342,-0.93442 1.86893,-1.86675 2.80078,-2.80273 -2.40634,-2.1828 -5.38803,-3.85411 -8.6679,-4.16111 -1.03304,-0.12211 -2.07554,-0.15928 -3.1153,-0.12991 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtisLogo);
export default __webpack_public_path__ + "static/media/Otis-logo.9cd9fa231f9a94cd679b86c50afff548.svg";
export { ForwardRef as ReactComponent };